// extracted by mini-css-extract-plugin
export default {"button":"OAuthImageButton__button___3AHJU"};